import { atom } from "jotai";

export const generalSettingsAtom = atom<any>({});
